import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const SurveySetting: FormizoSchema[] = [
  {
    header: "Default Survey Score",
  },
  {
    label: "Score",
    name: "SurveyDoc.Config.SurveyScore",
    format: "number",
    variant: "outlined",
  },
  {
    header: "Irrelevant",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.Irrelevant.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.Irrelevant.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.Irrelevant.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "Irrelevant Answer Set",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.IrrelevantAnswerSet.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.IrrelevantAnswerSet.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.IrrelevantAnswerSet.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "Incomplete",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.Incomplete.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.Incomplete.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.Incomplete.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "Incomplete Answer Set",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.IncompleteAnswerSet.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.IncompleteAnswerSet.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.IncompleteAnswerSet.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "relevant",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.relevant.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.relevant.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.relevant.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "relevant Answer Set",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.relevantAnswerSet.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.relevantAnswerSet.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.relevantAnswerSet.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "complete",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.complete.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.complete.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.complete.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    header: "complete Answer Set",
  },
  {
    label: "TC",
    name: "SurveyDoc.Config.Content.completeAnswerSet.TC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "SC",
    name: "SurveyDoc.Config.Content.completeAnswerSet.SC",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
  {
    label: "EN",
    name: "SurveyDoc.Config.Content.completeAnswerSet.EN",
    rows: 3,
    format: "textarea",
    variant: "outlined",
  },
];
